import { loadDataMemoryService } from "@/business/shared/session/infrastructure/services/loadDataMemoryService";
import { isMemoryEmptyService } from "@/business/shared/session/infrastructure/services/isMemoryEmptyService";
import { userAuthStore } from "@/business/auth/infrastructure/store/userAuthStore";

export const loadSession = {
  async execute(): Promise<void> {
    if (await isMemoryEmptyService.execute()) {
      const { user } = await loadDataMemoryService.execute();

      if (user !== null) {
        await userAuthStore().updateUserAuthSession(user);
      }
    }
  },
};